// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.toolbar-title h4[data-v-c86be94c] {\n  font-weight: 300;\n}\n.v-card__text[data-v-c86be94c] {\n  font-size: 1rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
